






















import Vue from "vue";

export default Vue.extend({
  name: "comment-delete-dialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    info: {
      type: Object,
      default: () => ({}),
    },
    tid: {
      type: String,
      default: "",
    },
    level: {
      type: String,
      default: "1",
    },
  },
  data() {
    return {};
  },
  methods: {
    stat(action: string, data: any) {
      this.$stat("xiaozhan", action, data);
    },
    close() {
      this.$emit("close");
    },
    iconClose() {
      this.close();
    },
    btnClose() {
      this.close();
    },
    async handleDelete() {
      try {
        await this.$store.dispatch("post/deleteFeedComment", {
          comment_id: this.info.comment_id,
          tid: this.tid,
          level: this.level,
          cid: this.info.origin_cid,
        });

        this.close();
        this.$message({
          message: "删除成功",
          type: "success",
        });
        this.stat("xiaozhan_comment_section_delete_result", {
          result: "success",
        });
      } catch (e) {
        this.stat("xiaozhan_comment_section_delete_result", {
          result: "fail",
        });
        this.$message({
          message: e.message || "删除失败，请稍后重试",
          type: "error",
        });
      }
    },
  },
});
